const androidClient = /\bGarageGymBrosAndroid\/1\b/;
export const isAndroidApp =
  typeof navigator !== 'undefined' && androidClient.test(navigator.userAgent);
export const androidNavigationEvent = 'ggb:android:navigate';

type AndroidMessage =
  | { type: 'share-link'; url: string }
  | { type: 'account-export'; data: unknown }
  | { type: 'auth-action' };
type AndroidWindow = Window & { garageAndroid?: { postMessage: (value: string) => void } };

function postToAndroid(message: AndroidMessage): boolean {
  if (!isAndroidApp) return false;
  const bridge = (window as AndroidWindow).garageAndroid;
  if (!bridge) return false;
  try {
    bridge.postMessage(JSON.stringify(message));
    return true;
  } catch {
    return false;
  }
}

export function shareOnAndroid(url: string) {
  // Preserve normal browser/clipboard behavior if the native share sheet is unavailable.
  return postToAndroid({ type: 'share-link', url });
}

export function saveExportOnAndroid(data: unknown) {
  return postToAndroid({ type: 'account-export', data });
}

export function showAuthOnAndroid() {
  return postToAndroid({ type: 'auth-action' });
}
